import clsx from 'clsx';
import { type HTMLAttributes, forwardRef } from 'react';

export type CardAccent = 'none' | 'coral' | 'sun' | 'leaf' | 'sky' | 'dusk';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  accent?: CardAccent;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { interactive = false, accent = 'none', className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={clsx('perch-card', className)}
      data-interactive={interactive || undefined}
      data-accent={accent === 'none' ? undefined : accent}
      {...rest}
    />
  );
});
